<template>
  <div class="par-material-box">
    <div class="material-box">
      <div v-for="(parItem, parIndex) in showDataArr" :key="parIndex" class="material-box-item">
        <div class="material-box-item-title d-flex justify-between">
          <div class="material-box-item-title-left d-flex">
            <div class="material-box-item-title-left-num">
              {{ parItem.stuffStepUid }}
            </div>
            <div class="material-box-item-title-left-content ml-1">
              {{ getTitle(parItem) }}
            </div>
            <div v-if="parItem.isEdit" class="material-box-item-title-left-edit ml-1">{{ $t('已改') }}</div>
          </div>
          <div class="material-box-item-title-right d-flex">
            <div class="time d-flex mr-1" :class="{'time-length': !!parItem.stuffCallTime }">
              <div class="time-title">{{ $t('呼叫时间') }}:</div>
              <div class="time-content">{{ parItem.stuffCallTime || '-' }}</div>
            </div>
            <div class="more mat-r">
              <div class="more-hover" @click="handleShowMore(parItem.id, !showMore[parItem.id])" @mouseenter="handleShowMore(parItem.id, true)" @mouseout="handleShowMore(parItem.id,false)">{{ $t('更多') }}</div>
              <div v-show="showMore[parItem.id]" class="more-hover-content">
                <div class="time-msg-box">
                  <div class="time-item d-flex">
                    <div class="time-item-title">
                      {{ $t('称料开始时间') }}
                    </div>
                    <div class="time-item-content">
                      {{ parItem.weighStartTime||'-' }}
                    </div>
                  </div>
                  <div class="time-item d-flex">
                    <div class="time-item-title">
                      {{ $t('称料结束时间') }}
                    </div>
                    <div class="time-item-content">
                      {{ parItem.weighEndTime||'-' }}
                    </div>
                  </div>
                  <div class="time-item d-flex">
                    <div class="time-item-title">
                      {{ $t('配送开始时间') }}
                    </div>
                    <div class="time-item-content">
                      {{ parItem.deliveryStartTime||'-' }}
                    </div>
                  </div>
                  <div class="time-item d-flex">
                    <div class="time-item-title">
                      {{ $t('配送结束时间') }}
                    </div>
                    <div class="time-item-content">
                      {{ parItem.deliveryEndTime||'-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="parItem.deliveryCodeDesc" class="delivery mat-r d-flex">
              <div class="delivery-bar"></div>
              <div class="delivery-title">{{ parItem.deliveryCodeDesc }}</div>
            </div>
            <div class="status d-flex mat-r">
              <div class="status-title">
                {{ $t('称料') }}
              </div>
              <div class="status-content">
                <div
                  class="tag-size"
                  :class="[
                    parItem.weighingStatus === 0 ? 'tag-info' : '',
                    parItem.weighingStatus === 25 ? 'tag-cancel' : '',
                    (parItem.weighingStatus === 10 || parItem.weighingStatus === 20 || parItem.weighingStatus === 30) ? 'tag-loading' : '',
                    parItem.weighingStatus === 40 ? 'tag-success' : '',
                    parItem.weighingStatus === 50 ? 'tag-fail' : ''
                  ]"
                >
                  <ku-text-ellipsis width="120px" :is-max-width="true" :content="parItem.weighingStatusDesc" style="margin-top:-3px" />
                </div>
              </div>
            </div>
            <div class="status d-flex mat-r">
              <div class="status-title">
                {{ $t('配送') }}
              </div>
              <div class="status-content">
                <div
                  class="tag-size"
                  :class="[
                    parItem.deliveryStatus === 0 ? 'tag-info' : '',
                    (parItem.deliveryStatus === 10 ||parItem.deliveryStatus === 20 || parItem.deliveryStatus === 30) ? 'tag-loading' : '',
                    parItem.deliveryStatus === 40 ? 'tag-success' : '',
                    parItem.deliveryStatus === 50 ? 'tag-fail' : ''
                  ]"
                >
                  <ku-text-ellipsis width="120px" :is-max-width="true" :content="parItem.deliveryStatusDesc" style="margin-top:-3px" />
                </div>
              </div>
            </div>
            <div class="btn">
              <ku-button
                v-if="showBtn(parItem)"
                type="primary"
                class="call-btn"
                @click="handleEditCall(parItem)"
              >
                {{ $t('编 辑') }}
              </ku-button>
              <ku-button
                v-if="showCallButton"
                type="primary"
                class="call-btn mr-0"
                :disabled="parItem.deliveryStatus !== 0&&parItem.deliveryStatus !== 10"
                @click="handleCallMaterial(parItem)"
              >
                {{ $t('呼 料') }}
              </ku-button>
            </div>

          </div>
        </div>
        <div class="material-box-item-table">
          <vxe-grid ref="xTable" highlight-hover-row highlight-current-row :border="true" :data="parItem.materials" :columns="parItem.tableColumn" row-id="id" class="small-table-style">
            <template #transferStatusDesc_default="{ row }">
              <div
                class="tag-size"
                :class="[
                  (row.transferStatus === 15 || row.transferStatus === 40 )? 'tag-success' : '',
                  (row.transferStatus === 65 || row.transferStatus === 90) ? 'tag-fail' : ''
                ]"
              >
                {{ row.transferStatusDesc }}
              </div>
            </template>
            <template #operation="{ row }">
              <ku-button type="text" style="color:#3a71ff;min-height:30px;height:30px;" @click="handleDetail(row)">{{ $t('查看') }}</ku-button>
            </template>
          </vxe-grid>
        </div>
      </div>
    </div>

    <ku-drawer
      size="600px"
      :visible.sync="isShowDetail"
      :hide-confirm="true"
      :title="$t('详情')"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="p-1">
        <div v-for="(item,index) in detailSource" :key="index" class="detail-item d-flex">
          <div class="detail-item-title">
            <ku-text-ellipsis width="199px" :content="item.label" />
          </div>
          <div class="detail-item-content">
            <ku-text-ellipsis width="301px" :content="item.value || '-'" />
          </div>
        </div>
      </div>
    </ku-drawer>

    <ku-dialog :title="$t('呼叫信息')" :append-to-body="true" width="544px" :visible.sync="isShowCallMsg" @confirm="handleCallConfirm" @cancel="handleCallCancel">
      <el-form
        ref="callForm"
        :model="{ feedingPositionNo }"
        :rules="{
          feedingPositionNo: [{ required: true, trigger: 'change', message: $t('请选择') }]
        }"
      >
        <el-form-item :label="$t('料桶号')" prop="feedingPositionNo">
          <el-radio-group v-model="feedingPositionNo" class="d-flex">
            <el-radio v-for="(item , index) in tankList" :key="index" :label="item.value" :border="true" class="w-100 mr-0">
              {{ item.key }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </ku-dialog>

    <ku-drawer
      size="888px"
      :loading="materialDrawer.btnLoading"
      :visible.sync="materialDrawer.isVisible"
      :title="$t('编辑料单')"
      :append-to-body="true"
      :modal-append-to-body="false"
      @confirm="handleMaterialConfirm"
      @close="handleMaterialClosed"
    >
      <ku-button type="primary" @click="handleAddRow">
        <i class="iconfont icon-add-lg" style="margin-right:8px;"></i>
        {{ $t('新增一行') }}
      </ku-button>
      <div class="title">
        {{ getTitle(materialDrawer.data) }}
      </div>
      <vxe-grid ref="xTable" v-bind="gridOptions" style="margin-top: 12px;" :columns="tableColumns" :height="tableHeight">
        <template #default_materialCode="{ row, $rowIndex }">
          <el-select
            v-model="row.materialCode"
            filterable
            clearable
            :placeholder="$t('请选择')"
            @change="handleMaterialChange($event, $rowIndex)"
            @clear="handleMaterialClear($event, $rowIndex)"
          >
            <el-option v-for="item in getMaterialList(row)" :key="item.id" :label="(item.code || '--') + '/' + (item.name || '--')" :value="item.code" />
          </el-select>
        </template>
        <template #default_workmanshipUnit="{ row }">
          <div>{{ row.workmanshipUnit || '-' }}</div>
        </template>
        <template #default_feedingType="{ row }">
          <el-select v-model="row.feedingType" filterable clearable default-first-option :placeholder="$t('请选择')">
            <el-option v-for="(item, device) in feedingOptions" :key="device" :label="item.desc" :value="item.code" />
          </el-select>
        </template>
        <template #default_ingredients="{ row }">
          <el-input v-model="row.ingredients" class="w-100" :placeholder="$t('请输入')" />
        </template>
        <template #default_operation="{ row }">
          <el-button type="text" style="font-size: 14px;" @click="handleDelete(row)">{{ $t('删除') }}</el-button>
        </template>
      </vxe-grid>
    </ku-drawer>
  </div>
</template>

<script>
import casApi from '@/api/cas';
import { baseCommonApi, baseMaterialApi } from '@klinx/base/src/api/index.js';
import { ccsRmsApi } from '@klinx/ccs/src/api/index.js';
import { initQueryParams } from '@klinx/utils/commons';
import { isZh } from '@klinx/utils/i18n';

export default {
  name: 'MaterialListView',
  props: {
    // 数据源叠加(滚动条往下滚动是加载的数据源叠加到原先的数据源上)
    isOverlay: {
      type: Boolean,
      default: false
    },
    // 查询参数
    params: {
      type: Object,
      default() {
        return {
          stuffCode: "",
          deviceType: "",
          batchReferenceNo: "",
          productionStatus: 0
        };
      }
    }
  },
  data() {
    return {
      permitEdit: false,
      permitDelete: false,
      tableHeight: '',
      groupOptions: [],
      feedingOptions: [],
      digitsValue: '',
      materialDrawer: {
        btnLoading: false,
        isVisible: false,
        data: {}
      },
      showMore: {},
      showDataArr: [],
      isShowDetail: false,
      detailSource: [],
      tableColumn: [
        {
          field: 'materialCode',
          title: this.$t('染化料编码'),
          minWidth: 140,
          align: 'left'
        },
        {
          field: 'materialName',
          title: this.$t('染化料名称'),
          minWidth: 230,
          align: 'left'
        },
        {
          field: 'concentration',
          title: this.$t('浓度'),
          minWidth: 124,
          align: 'left'
        },
        {
          field: 'workmanshipUnit',
          title: this.$t('浓度单位'),
          minWidth: 80,
          align: 'left'
        },
        {
          field: 'cost',
          title: this.$t('成本'),
          minWidth: 80,
          align: 'left'
        },
        {
          field: 'costUnit',
          title: this.$t('成本单位'),
          minWidth: 80,
          align: 'left'
        },
        {
          field: 'price',
          title: this.$t('单价'),
          minWidth: 80,
          align: 'left'
        },
        {
          field: 'priceUnit',
          title: this.$t('单价单位'),
          minWidth: 80,
          align: 'left'
        },
        {
          field: 'feedingTypeDesc',
          title: this.$t('加料方式'),
          minWidth: 100,
          align: 'left'
        },
        {
          field: 'ingredients',
          title: this.$t('用料'),
          minWidth: 100,
          align: 'left'
        },
        {
          field: 'actualIngredients',
          title: this.$t('实际用料\(g\)'),
          minWidth: 100,
          align: 'left'
        },
        {
          field: 'difference',
          title: this.$t('差额\(g\)'),
          minWidth: 100,
          align: 'left'
        },
        {
          field: 'differenceH',
          title: this.$t('差额百分比\(%\)'),
          minWidth: 120,
          align: 'left'
        },
        {
          field: 'transferStatusDesc',
          title: this.$t('状态'),
          minWidth: 93,
          align: 'left',
          slots: {
            default: 'transferStatusDesc_default'
          }
        },
        {
          field: 'weighStartTime',
          title: this.$t('称料开始时间'),
          minWidth: 180,
          align: 'left'
        },
        {
          field: 'weighEndTime',
          title: this.$t('称料结束时间'),
          minWidth: 180,
          align: 'left'
        },
        {
          field: 'deliveryStartTime',
          title: this.$t('送料开始时间'),
          minWidth: 180,
          align: 'left'
        },
        {
          field: 'deliveryEndTime',
          title: this.$t('送料结束时间'),
          minWidth: 180,
          align: 'left'
        },
        {
          field: 'operation',
          title: this.$t('操作'),
          slots: { default: 'operation' },
          fixed: 'right',
          width: 100
        }
      ],
      deliveryOptions: [],
      materialBoxKey: 0,
      materialQueryParams: initQueryParams({
        size: -1,
        model: { }
      }),
      allGroups: [],
      materialList: [],
      gridOptions: {
        data: [],
        border: false,
        rowKey: true,
        scrollY: { enabled: false },
        highlightHoverRow: true,
        resizable: false,
        keepSource: true,
        showOverflow: true,
        editRules: {
          feedingType: [{ required: true, message: this.$t('请选择') }],
          ingredients: [
            {
              trigger: 'blur',
              validator: ({ cellValue }) => {
                let reg = null;
                let msg = '';
                const cases = {
                  0: (_) => {
                    reg = /^(0|[1-9][0-9]*)$/;
                    msg = this.$t('请输入正整数');
                  },
                  1: (_) => {
                    reg = /^\d+(\.\d{1,1})?$/;
                    msg = this.$t('请输入数字且最多保留一位小数');
                  },
                  2: (_) => {
                    reg = /^\d+(\.\d{1,2})?$/;
                    msg = this.$t('请输入数字且数字最多保留两位小数');
                  },
                  3: (_) => {
                    reg = /^\d+(\.\d{1,3})?$/;
                    msg = this.$t('请输入数字且数字最多保留三位小数');
                  }
                };
                cases[this.digitsValue] && cases[this.digitsValue]();

                return new Promise((resolve, reject) => {
                  if (cellValue && !reg.test(cellValue)) {
                    reject(new Error(msg));
                  } else {
                    cellValue < 0 ? reject(new Error(this.$t('请输入有效数值(最小值为0)'))) : resolve();
                  }
                });
              }
            }
          ]
        },
        editConfig: { trigger: 'click', mode: 'cell', showStatus: false, showIcon: false }
      },
      materialGroupTypeArr: [],
      isShowCall: false,
      tankList: [],
      manualCallSetting: false,
      beforeStartPlanCallSetting: false,
      isShowCallMsg: false,
      feedingPositionNo: '',
      curDetailItem: {},
      isShowEditBtn: false
    };
  },
  computed: {
    showCallButton() {
      return this.isShowCall && this.manualCallSetting && this.tankList.length > 0 && (parseInt(this.params.productionStatus) === 0 || (this.beforeStartPlanCallSetting && parseInt(this.params.productionStatus) === 1));
    },
    tenant() {
      return this.$store.state.account.tenant;
    },
    tableColumns() {
      return [
        {
          field: 'materialCode',
          title: this.$t('染化料编码') + '/' + this.$t('名称'),
          showHeaderOverflow: true,
          minWidth: 306,
          align: 'left',
          slots: { default: 'default_materialCode' }
        },
        {
          field: 'workmanshipUnit',
          title: this.$t('浓度单位'),
          showHeaderOverflow: true,
          minWidth: 90,
          align: 'left',
          slots: { default: 'default_workmanshipUnit' }
        },
        {
          field: 'feedingType',
          title: this.$t('加料方式'),
          showHeaderOverflow: true,
          minWidth: 187,
          align: 'left',
          slots: { default: 'default_feedingType' }
        },
        {
          field: 'ingredients',
          title: this.$t('用料'),
          showHeaderOverflow: true,
          minWidth: 177,
          align: 'left',
          slots: { default: 'default_ingredients' }
        },
        {
          field: 'operation',
          visible: this.canDelete(),
          title: this.$t('操作'),
          slots: { default: 'default_operation' },
          showHeaderOverflow: true,
          fixed: 'right',
          width: 70
        }
      ];
    }
  },
  watch: {
    params: {
      handler(val) {
        this.getParameterByKey();
        this.getDyesGroups();
        this.getAllDyes();
        this.getStuffSetUp();
        this.getMaterialGroups();
        this.getFeedingMode();
        this.getDictCodes();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleCallConfirm() {
      this.$refs.callForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('是否呼料？'), this.$t('提示'), {
            type: 'warning',
            confirmButtonText: this.$t('确定'),
            cancelButtonText: this.$t('取消')
          }).then(() => {
            casApi.setCasStuffRecordCall({ feedingPositionNo: this.feedingPositionNo, id: this.curDetailItem.id }).then(res => {
              if (res.data.isSuccess && res.data.data) {
                this.$message.success(this.$t('呼料成功'));
                this.getCasStuffRecordCallLoad();
              } else {
                this.$message.error(this.$t('呼料失败'));
              }
            }).finally(_ => {
              this.handleCallCancel();
            });
          });
        } else {
          return false;
        }
      });
    },
    handleCallCancel() {
      this.isShowCallMsg = false;
      this.feedingPositionNo = '';
      this.curDetailItem = {};
      this.$refs.callForm.resetFields();
    },
    getParameterByKey() {
      baseCommonApi.getParameterByKey('WEB_CONFIG_CLOUD', this.tenant).then(res => {
        if (res.data.isSuccess) {
          const scriptContent = res.data.data?.value || '';
          const obj = scriptContent ? JSON.parse(scriptContent) : {};
          if (Object.keys(obj).includes('VUE_APP_CUSTOMER')) {
            this.isShowCall = obj['VUE_APP_CUSTOMER'] ? obj['VUE_APP_CUSTOMER'].includes('huafeng') : false;
          } else {
            this.isShowCall = false;
          }

          if (Object.keys(obj).includes('VUE_APP_CCS_EDIT_MATERIALS')) {
            this.isShowEditBtn = obj['VUE_APP_CCS_EDIT_MATERIALS'];
          } else {
            this.isShowEditBtn = false;
          }
        }
      });
    },
    showBtn(item) {
      return ((item.weighingStatus <= 10 && item.deliveryStatus < 20) || this.permitEdit) && this.isShowEditBtn;
    },
    canDelete() {
      const weighingStatus = this.materialDrawer.data?.weighingStatus;
      const deliveryStatus = this.materialDrawer.data?.deliveryStatus;
      return this.permitDelete && weighingStatus <= 10 && deliveryStatus < 20;
    },
    changeTableHeight() {
      const tableHeight = window.innerHeight - 220;
      if ((this.gridOptions.data.length + 1) * 48 > tableHeight) {
        this.tableHeight = tableHeight;
      } else {
        this.tableHeight = '';
      }
    },
    async handleMaterialConfirm() {
      const errMap = await this.$refs.xTable.validate(true).catch((errMap) => errMap);
      if (errMap) {
        this.$message.error(this.$t('请根据提示完善数据信息'));
      } else {
        casApi.editCallRecord({
          id: this.materialDrawer.data.id,
          materials: this.gridOptions.data
        }).then(res => {
          if (res.data.isSuccess) {
            this.$message.success(this.$t('修改成功'));
            this.handleMaterialClosed();
            this.getCasStuffRecordCallLoad();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    handleMaterialClosed() {
      this.gridOptions.data = [];
      this.materialDrawer.isVisible = false;
    },
    handleDelete(row) {
      const table = this.$refs.xTable;
      this.$confirm(this.$t('确认删除吗?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        table.remove(row);
        this.changeTableHeight();
      });
    },
    handleAddRow() {
      const table = this.$refs.xTable;
      let newRecord = {};
      newRecord = {
        actualIngredients: 0,
        batchNo: "",
        code: 0,
        concentration: 0,
        correctionNumber: "",
        cost: "",
        costUnit: "",
        deliveryEndTime: "",
        deliveryStartTime: "",
        deliveryStatus: "",
        difference: "",
        differenceH: "",
        feedingPosition: "",
        feedingPositionNo: 0,
        feedingType: "",
        heatProgram: "",
        ingredients: 0,
        materialCode: "",
        materialGroup: "",
        materialName: "",
        materialType: "",
        materialTypeCode: "",
        model: "",
        price: "",
        priceUnit: "",
        programCode: "",
        programName: "",
        remark: "",
        sort: 0,
        stepName: "",
        stuffCallTime: "",
        stuffCode: "",
        stuffStepUid: 0,
        transferStatus: "",
        weighEndTime: "",
        weighStartTime: "",
        weighingStatus: "",
        workmanshipUnit: ""
      };
      table.insertAt(newRecord, -1);
      const listData = table.getTableData().visibleData;
      this.gridOptions.data = listData;
      this.changeTableHeight();
    },
    getFeedingMode() {
      ccsRmsApi.getMaterialFeedingType().then((res) => {
        this.feedingOptions = res.data.data;
      });
    },
    getMaterialGroups() {
      this.allGroups = [];
      baseMaterialApi.dyesGroups().then((res) => {
        if (res.data.isSuccess) {
          res.data.data.forEach((i) => {
            const anObj = {};
            anObj.label = i.name;
            anObj.value = i.code;
            anObj.children = (i.member || []).map((v, ind) => ({
              ...v,
              label: v.name,
              value: v.id
            }));
            anObj.children && anObj.children.length > 0 && this.groupOptions.push(anObj);
            this.allGroups = this.allGroups.concat(i.member);
          });
        }
      });
    },
    getDyesGroups() {
      baseMaterialApi.dyesGroups().then(res => {
        this.materialGroupTypeArr = res.data ? (res.data.data || []) : [];
      });
    },
    handleMaterialChange(e, v) {
      this.formChanged = true;
      const exists = this.materialList.filter((item) => item.code === e);
      if (exists && exists.length > 0) {
        const materialItemData = exists[0];
        const groupId = materialItemData.groupId;
        const groupExists = this.allGroups.find((i) => i.id === groupId);

        this.gridOptions.data[v].workmanshipUnit = materialItemData.unit;
        this.gridOptions.data[v].materialGroup = groupExists?.name || '';
        this.gridOptions.data[v].materialTypeCode = groupExists?.groupType || '';
        this.gridOptions.data[v].materialType = this.getMaterialType(groupId);
        this.gridOptions.data[v].materialName = materialItemData.cnName;
        this.gridOptions.data[v].remark = materialItemData.remark;
        this.gridOptions.data[v].feedingType = materialItemData.feedingType?.code;
        this.gridOptions.data[v].cost = '';
        this.gridOptions.data[v].correctionNumber = materialItemData.correctionNumber;
        this.gridOptions.data[v].costUnit = '-';
        this.gridOptions.data[v].price = materialItemData.price;
        this.gridOptions.data[v].priceUnit = materialItemData.priceUnit;
      }
    },
    getMaterialType(groupId) {
      if (this.materialGroupTypeArr.length === 0) return '';
      let materialType = '';
      this.materialGroupTypeArr.map(parItem => {
        const name = parItem.name;
        const exists = (parItem.member || []).find(childItem => childItem.id === groupId);
        exists && (materialType = name);
      });

      return materialType;
    },
    /**
     * 清空染化料编码
     */
    handleMaterialClear(e, v) {
      this.formChanged = true;
      const arr = ['workmanshipUnit', 'materialGroup', 'materialTypeCode', 'materialType', 'materialName', 'remark', 'feedingType', 'cost', 'costUnit', 'price', 'priceUnit', 'correctionNumber'];
      arr.forEach((key) => {
        this.gridOptions.data[v][key] = '';
      });
    },
    getStuffSetUp() {
      ccsRmsApi.getStuffSetUp('DYEING').then(res => {
        const result = res.data.data;
        const decimalPoint = result.decimalPoint.code;
        const cases = {
          THREE: _ => { this.digitsValue = 3; },
          TWO: _ => { this.digitsValue = 2; },
          ONE: _ => { this.digitsValue = 1; },
          NONE: _ => { this.digitsValue = 0; }
        };

        cases[decimalPoint] && cases[decimalPoint]();
      });
    },
    getAllDyes() {
      baseMaterialApi.dyesPage(this.materialQueryParams).then((res) => {
        this.materialList = (res.data?.data?.records || []).map((item) => {
          return {
            ...item,
            name: isZh() ? item.cnName : item.enName
          };
        });
      });
    },
    getMaterialList(row) {
      const newMaterialList = JSON.parse(JSON.stringify(this.materialList));
      const exists = newMaterialList.filter((ele) => ele.code === row.materialCode);
      if (exists && exists.length > 0) {
        return newMaterialList;
      } else {
        newMaterialList.push({
          id: -1,
          disabled: true,
          code: row.materialCode,
          name: row.materialName
        });
        return newMaterialList;
      }
    },
    // 查看
    handleDetail(row) {
      this.detailSource = [];
      const newColumns = this.tableColumn.filter(item => item.field !== 'operation');
      newColumns.map(item => {
        this.detailSource.push({
          label: item.title,
          value: Object.keys(row).includes(item.field) ? row[item.field] : '-'
        });
      });
      this.isShowDetail = true;
    },
    getDictCodes() {
      baseCommonApi.getDictCodes({ 'codes[]': 'ICAS_DELIVERY_CODE' }).then((response) => {
        const res = response.data.data;
        this.deliveryOptions = res.ICAS_DELIVERY_CODE.map((item) => {
          return {
            ...item,
            name: item.name,
            value: item.code
          };
        });
        this.getCasStuffRecordCallLoad();
      });
    },
    handleShowMore(id, isShow) {
      this.showMore = {
        ...this.showMore,
        [id]: isShow
      };
    },
    getTitle(parItem) {
      return (parItem?.stepName || '-') + '#' + (parItem?.programCode || '-') + '#' + (parItem?.programName || '-');
    },
    handleEditCall(item) {
      this.materialDrawer.isVisible = true;
      this.materialDrawer.data = { ...item };
      this.gridOptions.data = (item.materials || []).map(item => {
        let obj = {};
        Object.keys(item).map(el => {
          obj = {
            ...obj,
            [el]: item[el] === '-' ? "" : item[el]
          };
        });
        return obj;
      });
    },
    /**
     * 呼叫打料
     */
    handleCallMaterial(item) {
      this.isShowCallMsg = true;
      this.feedingPositionNo = '';
      this.curDetailItem = { ...item };
      this.$nextTick(_ => {
        this.$refs.callForm.resetFields();
      });

      // this.$confirm(this.$t('是否呼料？'), this.$t('提示'), {
      //   type: 'warning',
      //   confirmButtonText: this.$t('确定'),
      //   cancelButtonText: this.$t('取消')
      // }).then(() => {
      //   casApi.setCasStuffRecordCall({ id: item.id }).then(res => {
      //     if (res.data.isSuccess && res.data.data) {
      //       this.$message.success(this.$t('呼料成功'));
      //       this.getCasStuffRecordCallLoad();
      //     } else {
      //       this.$message.error(this.$t('呼料失败'));
      //     }
      //   });
      // });
    },
    /**
     * 获取查看料单步骤数据源
     */
    getCasStuffRecordCallLoad() {
      this.showMore = {};
      const allDetailFields = this.tableColumn.map(item => item.field);
      this.params && Object.keys(this.params).length > 0 && casApi.getCasStuffRecordCallLoad({ ...this.params }).then(res => {
        if (Object.keys(res).length > 0) {
          const result = (res.data.data || []).map(parItem => {
            this.showMore = {
              ...this.showMore,
              [parItem.id]: false
            };
            const deliveryCodeObj = this.deliveryOptions.find(ele => `${ele.value}` === `${parItem.deliveryCode}`);
            const deliveryCodeDesc = deliveryCodeObj?.name;

            const weighingStatusDesc = this.getWeighingStatusDesc(parItem.weighingStatus);
            const deliveryStatusDesc = this.getdeliveryStatusDesc(parItem.deliveryStatus);
            const tableColumn = JSON.parse(JSON.stringify(this.tableColumn));

            parItem.materials = (parItem.materials || []).map(childItem => {
              childItem = {
                ...childItem,
                feedingTypeDesc: childItem.feedingType?.desc,
                feedingType: childItem.feedingType?.code
              };

              allDetailFields.map(key => {
                childItem = {
                  ...childItem,
                  [key]: Object.keys(childItem).includes(key) ? (childItem[key] || '-') : '-'
                };
              });

              childItem = {
                ...childItem,
                transferStatusDesc: this.getTransferStatusDesc(childItem.transferStatus)
              };
              return childItem;
            });
            parItem.tableColumn = tableColumn;
            return {
              ...parItem,
              deliveryCodeDesc,
              weighingStatusDesc,
              deliveryStatusDesc
            };
          });

          const deviceId = result.find(ele => ele.deviceId)?.deviceId || '';
          this.getSetting(deviceId);
          this.showDataArr = this.isOverlay ? [...this.showDataArr, ...result] : result;
        } else {
          this.showDataArr = [];
        }
      }).catch(_ => {
        this.showDataArr = [];
      });
    },
    getSetting(deviceId) {
      ccsRmsApi.getBindArchitectureByDeviceId({ deviceId }).then(res => {
        const result = res.data.data;
        const architectureId = result[deviceId].architectureId;

        return ccsRmsApi.getTransferConfig({ architectureId });
      }).then(res => {
        const result = res.data?.data;
        this.permitEdit = !!result?.permitEdit;
        this.permitDelete = !!result?.permitDelete;
        this.manualCallSetting = !!result?.manualCallSetting;
        this.beforeStartPlanCallSetting = !!result?.beforeStartPlanCallSetting;
        this.tankList = result?.tankList || [];
      });
    },
    getWeighingStatusDesc(weighingStatus) {
      let weighingStatusDesc = '';
      const cases = {
        0: _ => {
          // 未准备
          weighingStatusDesc = this.$t('未准备');
        },
        10: _ => {
          // 请求称料
          weighingStatusDesc = this.$t('请求称料');
        },
        20: _ => {
          // 排队中
          weighingStatusDesc = this.$t('排队中');
        },
        25: _ => {
          // 取消
          weighingStatusDesc = this.$t('取 消');
        },
        30: _ => {
          // 称料中
          weighingStatusDesc = this.$t('称料中');
        },
        40: _ => {
          // 称料成功
          weighingStatusDesc = this.$t('称料成功');
        },
        50: _ => {
          // 称料失败
          weighingStatusDesc = this.$t('称料失败');
        }
      };

      cases[weighingStatus] && cases[weighingStatus]();
      return weighingStatusDesc;
    },
    getdeliveryStatusDesc(deliveryStatus) {
      let deliveryStatusDesc = '';
      const cases = {
        0: _ => {
          // 未准备
          deliveryStatusDesc = this.$t('未准备');
        },
        10: _ => {
          // 准备
          deliveryStatusDesc = this.$t('准备');
        },
        20: _ => {
          // 配送请求
          deliveryStatusDesc = this.$t('配送请求');
        },
        30: _ => {
          // 配送中
          deliveryStatusDesc = this.$t('配送中');
        },
        40: _ => {
          // 配送成功
          deliveryStatusDesc = this.$t('配送成功');
        },
        50: _ => {
          // 配送失败
          deliveryStatusDesc = this.$t('配送失败');
        }
      };
      cases[deliveryStatus] && cases[deliveryStatus]();
      return deliveryStatusDesc;
    },
    getTransferStatusDesc(transferStatus) {
      let transferStatusDesc = '';
      const cases = {
        15: _ => {
          // 称料完成
          transferStatusDesc = this.$t('称料完成');
        },
        65: _ => {
          // 称料失败
          transferStatusDesc = this.$t('称料失败');
        },
        40: _ => {
          // 送料完成
          transferStatusDesc = this.$t('送料完成');
        },
        90: _ => {
          // 送料失败
          transferStatusDesc = this.$t('送料失败');
        }
      };
      cases[transferStatus] && cases[transferStatus]();
      return transferStatusDesc;
    }
  }
};
</script>

<style lang='scss' scoped>
.mat-r{
  margin-right: 12px;
}

::v-deep .small-table-style .vxe-header--row .vxe-header--column .vxe-cell--title {
  line-height: 18px !important;
}
.par-material-box{
  display: flex;
  flex-direction: column;
  height: 100%;
  .material-box{
    width: 100%;
    flex: 1;
    background-color: #F2F3F5;
    padding:0px 20px;
    &-item{
      margin-top: 15px;
      background-color: white;
      position: relative;
      &-title{
        height: 56px;
        padding: 12px 15px;
        border-bottom: 1px solid #f2f3f5;
        &-left{
          &-num{
            color: #FF6900;
            font-weight: 700;
            font-size: 24px;
            height: 24px;
            line-height: 24px;
            background-color: #FFF5E8;
            padding: 0px 5px;
            margin-top:5px;
          }
          &-content{
            padding-top:7px;
            color:#3D3D3D;
            font-weight: 600;
            font-size: 16px;
          }
          &-edit{
            color: #F45656;
            background-color: #FEE6E6;
            border-radius: 2px;
            padding: 8px;

            font-family: PingFang SC;
            font-size: 13px;
            font-weight: normal;
            display: flex;
            align-items: center;
            letter-spacing: 0px;
          }
        }
        &-right{
          .delivery{
            padding-top:5px;
            font-size: 12px;
            font-weight: 400;
            height: 26px;
            line-height: 26px;
            .delivery-bar{
              background-color: #E5E6EB;
              width: 1px;
              height: 10px;
              margin-top: 8px;
            }
            .delivery-title{
              margin-left: 12px;
              color:#4E5969;
              margin-right: 5px;
            }
          }
          .time{
            padding-top:5px;
            font-size: 12px;
            font-weight: 400;
            height: 26px;
            line-height: 26px;
            .time-title{
              color:#4E5969;
              margin-right: 5px;
            }
            .time-content{
              color:#1D2129;
            }
          }
          .time-length{
            min-width: 210px;
          }
          .more{
            padding-top:12px;
            position: relative;
            .more-hover{
              font-size: 12px;
              font-weight: 400;
              color: $main;
              cursor: pointer;
            }
            .more-hover-content{
              box-shadow: 0 4px 12px rgba(0,0,0,.06);
              border-radius: 2px;
              min-Width: 365px;
              height: 192px;
              background-color: white;
              position: absolute;
              z-index: 999;
              top: 35px;
              left: -34px;
              font-size: 14px;
              .time-msg-box{
                margin: 12px;
                .time-item{
                  .time-item-title{
                    height: 42px;
                    line-height: 42px;
                    padding-left: 10px;
                    padding-right: 10px;
                    min-width: 169px;
                    background-color: #F7F8FA;
                    border-top: 1px solid #E5E6EB;
                    border-left: 1px solid #E5E6EB;
                  }
                  .time-item-content{
                    height: 42px;
                    line-height: 42px;
                    width: 100%;
                    padding-left: 10px;
                    padding-right: 10px;
                    border: 1px solid #E5E6EB;
                    border-bottom: none;
                  }
                }
                .time-item:last-child{
                  border-bottom: 1px solid #E5E6EB;
                }
              }
            }
          }
          .status{
            padding-top:5px;
            font-size: 12px !important;
            font-weight: 400 !important;
            .status-title{
              color: #1D2129;
              background-color:#E5E6E8;
              height: 26px;
              line-height: 26px;
              padding:0px 10px;
            }
            .status-content{
              min-width: 70px;
            }
          }
          .btn{
            .call-btn{
              height: 32px;
              min-width: 88px;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
      }
      &-table{
        padding: 15px;
      }
    }
    &-item:last-child{
      margin-bottom: 60px;
    }
  }
}

.title{
  margin-top: 12px;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  padding-right: 16px;
  width: 100%;

  border: 1px solid #E5E6EB;
  border-radius: 2px;
  background: #F7F8FA;

  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #3D3D3D;
}

.detail-item{
  .detail-item-title{
    height: 42px;
    line-height: 42px;
    padding-left: 10px;
    padding-right: 10px;
    min-width: 219px;
    background-color: #F7F8FA;
    border-top: 1px solid #E5E6EB;
    border-left: 1px solid #E5E6EB;
  }
  .detail-item-content{
    height: 42px;
    line-height: 42px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    border: 1px solid #E5E6EB;
    border-bottom: none;
  }
}
.detail-item:last-child{
  border-bottom: 1px solid #E5E6EB;
}

.tag-size {
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  height: 26px;
  line-height: 26px;
  text-align: center;
}
.tag-info {
  color: #4E5969;
  background-color: #F0F1F2;
}

.tag-fail {
  color: #F45656;
  background-color: #FEE6E6;
}

.tag-loading {
  background-color: #E6EDFF;
  color: #3A71FF;
}

.tag-cancel{
  background-color: #FFF4C9;
  color: #FFAA00;
}

.tag-success{
  background-color: #E0F6E5;
  color: #00B42A;
}

::v-deep .vxe-table--render-default .vxe-cell {
    word-break: break-word !important;
}
</style>
